module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_chapel-c998f7744cd218af83fa62fb2ba6f0e4.webp";